/**
 * Constantes compartilhadas entre Chat.tsx e ChatHubPage.tsx
 * Extraídas para evitar duplicação
 */
import { T } from '../styles/tokens';

/** Cores dos ícones de ferramentas (tool actions) */
export const CHAT_COLORS = {
  amber: '#D4A053',
  purple: '#8B7EC8',
  blue: '#5B8AD4',
  cyan: '#4DB8C7',
  green: '#5DAA8C',
  gray: T.textMuted,
} as const;

/** Cores por extensão de arquivo */
export const FILE_EXTENSION_COLORS: Record<string, string> = {
  pdf: T.danger,
  doc: '#2B579A',
  docx: '#2B579A',
  xls: '#217346',
  xlsx: '#217346',
  zip: T.warning,
  rar: T.warning,
  txt: T.textMuted,
  md: T.textMuted,
  json: T.warning,
  csv: T.success,
  py: '#3776AB',
  js: '#F7DF1E',
  ts: '#3178C6',
  html: '#E44D26',
};

/** Cor padrão para extensões não mapeadas */
export const FILE_EXTENSION_DEFAULT_COLOR = '#5B8AD4';
